import React, { useEffect, useRef } from "react";
import FlightCardMobile from "./components/FlightCardBound";
import FlightCardDesktop, { FlightCardBoundProps } from "./components/FlightCardBound.desktop";
import useUserAgent from "../../../hooks/useUserAgent";
import Frame from "../Frame";
import useTrackViAA from "../../../hooks/useTrackViAA";
import useIsInViewport from "../../../hooks/useIsInViewport";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { useStickySearchBoxExp } from "../../../utils/experiments/mdotvalue/flights_mdotvalue_sr_sticky_search_box";

type Props = FlightCardBoundProps;

const _FlightCard = (props: Props) => {
  const { flight, index, onClick, bigLogo, searchType, mt, mb } = props;
  const { isMobile } = useUserAgent();
  const FlightCard = isMobile || props.isAlternativeFareCard ? FlightCardMobile : FlightCardDesktop;
  const i18n = useI18n();
  const { trackScrollToThird, trackScrollToFifth } = useStickySearchBoxExp(); //@exp flights_mdotvalue_sr_sticky_search_box

  //@start flights_mdotvalue_sr_sticky_search_box flights_web_aa_virtual_interlining_tracking
  const ref = useRef<HTMLDivElement>(null);
  const isInViewport = useIsInViewport(ref.current);
  //@end flights_mdotvalue_sr_sticky_search_box flights_web_aa_virtual_interlining_tracking

  // flights_web_aa_virtual_interlining_tracking -- start
  const trackViAA = useTrackViAA();
  useEffect(() => {
    trackViAA.ViAAInStage1();
    if (!isInViewport) return;
    trackViAA.ViAAInStage2(flight);
  }, [isInViewport, trackViAA, flight]);
  // flights_web_aa_virtual_interlining_tracking -- end

  //@start flights_mdotvalue_sr_sticky_search_box
  useEffect(() => {
    if (isInViewport && index === 3) {
      trackScrollToThird();
    } else if (isInViewport && index === 5) {
      trackScrollToFifth();
    }
  }, [index, isInViewport, trackScrollToFifth, trackScrollToThird]);
  //@end flights_mdotvalue_sr_sticky_search_box

  return (
    <Frame
      mt={mt}
      mb={mb}
      elementRef={ref}
      attributes={{ role: "group", "aria-label": i18n.trans(t("a11y_flights_search_card_begin")) }}
    >
      <FlightCard
        flight={flight}
        onClick={() => {
          trackViAA.ViAAInStage3(flight);
          trackViAA.ViAAInStage4(flight);
          onClick(flight);
        }}
        pricePerPerson
        index={index}
        bigLogo={bigLogo}
        searchType={searchType}
        forceHideLastAvailableSeats={props.forceHideLastAvailableSeats}
        isAlternativeFareCard={props.isAlternativeFareCard}
        /* start - flights_alternative_fares_for_price_change_and_sold_out_errors_web */
        viewFlightDetailsCtaLabel={props.viewFlightDetailsCtaLabel}
        disabled={props.disabled}
        /* end - flights_alternative_fares_for_price_change_and_sold_out_errors_web */
      />
    </Frame>
  );
};

const FlightCard = React.memo(_FlightCard);

export default FlightCard;
